import { API } from '@/models/core'
import moment from 'moment'
import { GamePreview } from '@/models/fantasygame/core'
import Vue from 'vue'

export class Contest {
  constructor () {
    this.key = null
    this.app = null
    this.points_setup = {"points_model": null, "boosts_rate" : [2.5, 1.5]}
    this.sport = null
    this.name = null
    this.rule = null
    this.reward = null
    this.desc = null
    this.code = null
    this.leaderBoard = true
    this.is_archived = false
  }
  static createFromJson (raw) {
    let contest = new Contest()
    contest = Object.assign(contest, raw)
    contest.rule = raw.rule.key
    contest.reward = raw.rewards.key
    contest.code = raw.join_code
    contest.points_setup = raw.pointsystem
    return contest
  }
  static createContest (postData) {
    postData.app = API.faKey
    let params = postData
    return API.instance().post(`/fantasy-app/${API.faKey}/contest/`, params).then((resp) => {
      return resp.data
    })
  }
 
  static getContest (key) {
    let params = {}
    return API.instance().get(`/fantasy-app/${API.faKey}/contest/?key=${key}`, params).then((resp) => {
      return Contest.createFromJson(resp.data.data)
    })
  }

  static games (contestKey) {
    let params = {}
    return API.instance().get(`/fantasy-game/${API.faKey}/contest/${contestKey}/games/`, params).then((resp) => {
      const data = resp.data.data
      const cursor = data.cursor
      const previews = data.previews.map(x => GamePreview.createFromJson(x))
      return { cursor, previews }
    })
  }
  static deleteContest (contest) {
    return API.instance().post(`/fantasy-app/${API.faKey}/contest/`, contest).then((resp) => {
      return resp.data
    })
  }
}

export class UserHome {
  static fetch () {
    let params = {}
    return API.instance().get(`/fantasy-app/${API.faKey}/default_contest_template/`, params).then((resp) => {
      return resp.data.data
    })
  }

  static getHome (cursor) {
    let url
    if (cursor) {
      url = `/fantasy-app/${API.faKey}/all_contests/?last=${cursor.last}&&lastkey=${cursor.lastkey}&&total=${cursor.total}`
    } else {
      url = `/fantasy-app/${API.faKey}/all_contests/`
    }
    let params = {}
    return API.instance().get(url, params).then((resp) => {
      return UserHome.createFromJson(resp.data.data)
    })
  }

  static createFromJson (raw) {
    let home = new UserHome()
    home = Object.assign(home, raw)
    for (let contest of home.contests) {
      contest['addToFeature'] = false
    }
    return home
  }

  static searchContest (key, cursor) {
    let url
    if (cursor) {
      url = `/fantasy-app/${API.faKey}/contest-search/?keyword=${key}&&last=${cursor.last}`
    } else {
      url = `/fantasy-app/${API.faKey}/contest-search/?keyword=${key}`
    }
    let params = {}
    return API.instance().get(url, params).then((resp) => {
      return UserHome.createFromJson(resp.data.data)
    })
  }
}

export class FeaturedContest {
  constructor () {
    this.key = null
    this.rank = null
    this.contest_key = null
    this.online_date = null
    this.offline_date = null
  }
  static featuredContest (postData) {
    postData.online_date =   moment(postData.online_date).format('YYYY-MM-DD')
    postData.offline_date =   moment(postData.offline_date).format('YYYY-MM-DD')
    let params = postData
    return API.instance().post(`/fantasy-app/${API.faKey}/add_featured_contest/`, params).then((resp) => {
      return resp.data.data
    })
  }

  static createFromJson (raw) {
    if (raw.error) {
      return raw
    } else {
      let featuredContest = new FeaturedContest()
      featuredContest = Object.assign(featuredContest, raw.data)
      featuredContest.featured_contests.forEach((contest) => {
        contest['changeRank'] = false
        Contest.getContest(contest.contest.key).then((resp) => {
          Vue.set(contest, 'contest', resp);
        })
      })
      return featuredContest
    }
  }

  static getFeaturedContest () {
    let params = {}
    return API.instance().get(`/fantasy-app/${API.faKey}/all_featured_contests/`, params).then((resp) => {
      return FeaturedContest.createFromJson(resp.data)
    })
  }
}
